import { render, staticRenderFns } from "./UsuarioCliente.vue?vue&type=template&id=69dc606e&scoped=true&"
import script from "./UsuarioCliente.vue?vue&type=script&lang=js&"
export * from "./UsuarioCliente.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioCliente.vue?vue&type=style&index=0&id=69dc606e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc606e",
  null
  
)

export default component.exports